<div
  class="toast-shell relative grid grid-cols-[auto,minmax(0,1fr),auto] items-center gap-[0.72rem] overflow-hidden rounded-[20px] px-[0.82rem] py-[0.82rem] pl-[0.76rem] sm:gap-[0.9rem] sm:rounded-[24px] sm:px-4 sm:py-4 sm:pl-[0.95rem]"
  [ngClass]="toneClass"
  [attr.role]="accessibilityRole"
  [attr.aria-live]="ariaLive"
>
  <span class="toast-shell__glow absolute inset-0 pointer-events-none" aria-hidden="true"></span>
  <span class="toast-shell__glare absolute inset-0 pointer-events-none" aria-hidden="true"></span>

  <div class="toast-shell__orb relative z-[1] grid h-10 w-10 place-items-center rounded-2xl sm:h-12 sm:w-12 sm:rounded-[18px]" aria-hidden="true">
    @switch (type) {
      @case (ToastType.SUCCESS) {
        <svg class="h-[1.1rem] w-[1.1rem] sm:h-[1.35rem] sm:w-[1.35rem]" viewBox="0 0 20 20" fill="none">
          <path d="M5 10.4 8.2 13.6 15 6.8" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"></path>
        </svg>
      }
      @case (ToastType.ERROR) {
        <svg class="h-[1.1rem] w-[1.1rem] sm:h-[1.35rem] sm:w-[1.35rem]" viewBox="0 0 20 20" fill="none">
          <path d="M6 6 14 14M14 6 6 14" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"></path>
        </svg>
      }
      @case (ToastType.WARNING) {
        <svg class="h-[1.1rem] w-[1.1rem] sm:h-[1.35rem] sm:w-[1.35rem]" viewBox="0 0 20 20" fill="none">
          <path d="m10 3.9 6 10.5a1 1 0 0 1-.87 1.5H4.87A1 1 0 0 1 4 14.4L10 3.9Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"></path>
          <path d="M10 7.3v4.6" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"></path>
          <circle cx="10" cy="14.1" r="1" fill="currentColor"></circle>
        </svg>
      }
      @default {
        <svg class="h-[1.1rem] w-[1.1rem] sm:h-[1.35rem] sm:w-[1.35rem]" viewBox="0 0 20 20" fill="none">
          <circle cx="10" cy="10" r="6.7" stroke="currentColor" stroke-width="1.5"></circle>
          <path d="M10 8.4v4.1" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"></path>
          <circle cx="10" cy="5.9" r="1" fill="currentColor"></circle>
        </svg>
      }
    }
  </div>

  <div class="toast-shell__content relative z-[1] min-w-0">
    <p class="toast-shell__label m-0 mb-[0.16rem] text-[0.58rem] font-bold uppercase leading-none tracking-[0.14em] sm:mb-[0.22rem] sm:text-[0.68rem] sm:tracking-[0.18em]">{{ statusLabel }}</p>
    <p class="toast-shell__message m-0 text-[0.84rem] font-semibold leading-[1.34] sm:text-[0.96rem] sm:leading-[1.4]">{{ message }}</p>
  </div>

  <button
    class="toast-shell__close relative z-[1] inline-grid h-[1.72rem] w-[1.72rem] place-items-center rounded-full p-0 sm:h-8 sm:w-8"
    type="button"
    [attr.aria-label]="closeLabel"
    (click)="closeToast()"
  >
    <svg class="h-[0.8rem] w-[0.8rem] sm:h-[0.95rem] sm:w-[0.95rem]" viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <path d="M6 6 14 14M14 6 6 14" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"></path>
    </svg>
  </button>
</div>
